import { Box } from '@mui/material';
import { useState } from 'react';
import { FormTitleBox, LoadingSkeleton, ConfirmationDialog, TableBodySkeleton } from '../../../common/components';
import AllotmentsDataTable from './components/AllotmentsDataTable';
import AllotmentsPagination from './components/AllotmentsPagination';
import AllotmentDialog from './components/AllotmentDialog';
import AllotmentPlanDialog from './components/AllotmentPlanDialog';
import { useAllotmentsTable } from './hooks/useAllotmentsTable';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import usePermissions from '../../../hooks/usePermissions';

const AllotmentsTable = () => {
  const { permissions } = usePermissions();
  const canEditLots = Boolean(permissions?.canEditLots);
  const {
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    searchTerm,
    dialogOpen,
    editMode,
    selectedAllotment,
    selectedImageFile,
    imageError,
    deleteConfirmOpen,
    allotmentToDelete,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleOpenDialog,
    handleCloseDialog,
    handleInputChange,
    handleImageChange,
    handleSave,
    handleEdit,
    handleDelete,
    handleConfirmDelete,
    handleCancelDelete,
  } = useAllotmentsTable();
  const [planPreview, setPlanPreview] = useState({ open: false, url: '', name: '' });

  const handleOpenPlan = (allotment) => {
    if (!allotment?.image_url) {
      return;
    }
    setPlanPreview({ open: true, url: allotment.image_url, name: allotment.name });
  };

  const handleClosePlan = () => {
    setPlanPreview({ open: false, url: '', name: '' });
  };

  return (
    <Box>
      <FormTitleBox
        title="Obra | Lotes | Loteos"
        showButton={true}
        buttonText="Agregar Loteo"
        buttonIcon={HomeWorkIcon}
        onButtonClick={handleOpenDialog}
        buttonProps={{ disabled: !canEditLots }}
        showSearch={true}
        searchLabel="Buscar loteo"
        searchValue={searchTerm}
        onSearchChange={handleSearch}
        searchSize="medium"
      />

      <AllotmentsDataTable
        data={data}
        isLoading={isLoading}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onViewPlan={handleOpenPlan}
        LoadingComponent={TableBodySkeleton}
        canEditLots={canEditLots}
      />

      <AllotmentsPagination
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <AllotmentDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        editMode={editMode}
        selectedAllotment={selectedAllotment}
        onInputChange={handleInputChange}
        onSave={handleSave}
        imageFile={selectedImageFile}
        imageError={imageError}
        onImageChange={handleImageChange}
        canEditLots={canEditLots}
      />

      <ConfirmationDialog
        open={deleteConfirmOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        title="Eliminar Loteo"
        message={`¿Está seguro que desea eliminar el loteo "${allotmentToDelete?.name}"?`}
        confirmText="Eliminar loteo"
        confirmDisabled={!canEditLots}
      />

      <AllotmentPlanDialog
        open={planPreview.open}
        onClose={handleClosePlan}
        title={planPreview.name ? `Plano | ${planPreview.name}` : 'Plano del loteo'}
        imageUrl={planPreview.url}
      />
    </Box>
  );
};

export default AllotmentsTable;
